import { API_BASE } from 'config'

import { createFetcher } from './createFetcher'

const fetcher = createFetcher({
  baseURL: API_BASE,
  cache: false,
} as any)

// compatibility for old usages
export const get = fetcher.get
export const getObj = fetcher.getObj
export const getObj2 = fetcher.getObj2
export const post = fetcher.post
export const postInvalidate = fetcher.postInvalidate
export const postMultipart = fetcher.postMultipart
export const put = fetcher.put
export const put2 = fetcher.put2
export const sendDelete = fetcher.sendDelete

export default fetcher
